const $ = require('jquery');
const LocalStorageSupport = require('./LocalStorageSupport');
const Utils = require('./utils');

'use strict';

const PLUGIN_NAME = 'tagsAutocomplete';
const LOCALSTORAGE_STATE_KEY = 'kmFeedSearchState';

const	DEFAULTS = {
  url: '',
  targetInputName: 'frm.tagIds',
  messages: {
    closeTag: 'Odebrat z filtru'
  },
  events: {
    resultRendered: 'AUTOCOMPLETE_RESULT_RENDERED',
    tagSelected: 'AUTOCOMPLETE_TAG_SELECTED',
    tagSelectedByUser: 'AUTOCOMPLETE_TAG_SELECTED_BY_USER',
    disclaimerTagSelected: 'KM_DISCLAIMER_NEEDED'
  },
  disableFormSubmit: false,
  lockTagsFromParams: false,
  getRememberedState: false,
  enableHtml5History: false
};

/**
 *
 * @param selector
 * @param options
 * @constructor
 */
const TagsAutocomplete = function (selector, options) {
  this.$t = $(selector);
  this.options = $.extend(true, {}, DEFAULTS, options);
  this._defaults = DEFAULTS;
  this.initialise_();
};

/**
 *
 * @private
 */
TagsAutocomplete.prototype.initialise_ = function () {
  this.$input = $('input', this.$t);
  this.inputPaddingLeft = parseInt(this.$input.css('padding-left'));
  this.$form = this.$t.parents('form:first');
  this.$fulltext = $('input[name="frm.fulltext"]', this.$form);

  this.keyUpTimer = null;
  this.$renderedResult = null;
  this.valBeforeKeyPress = '';
  this.selectedItem = -1;
  this.$renderedUsedTagsContainer = null;
  this.frontendAuthorTagUsed = window.frontendAuthorTagUsed;

  this.$input.attr('autocomplete', 'off');
  this.ls = new LocalStorageSupport();
  this.utils = new Utils();

  this.historySupported = history && history.replaceState && history.pushState;

  this.initLocalStorage_();
  this.$renderedUsedTagsContainer = this.prepareContainerForRenderedUsedTags_();

  if (this.options.getRememberedState) {
    this.getRememberedState_('ls');
  }

  this.bindEvents_();
  this.renderInitialTags_();

  if (this.options.enableHtml5History) {
    this.activateHistoryHandler_();
  }
};

TagsAutocomplete.prototype.bindEvents_ = function () {
  const self_ = this;

  this.bindTextEntering_();
  this.bindFulltextEvents_();
  this.bindTagsEvents_();
};

/**
 *
 * @private
 */
TagsAutocomplete.prototype.bindTextEntering_ = function () {
  const self_ = this;

  this.$input.on('keyup.ta_', (e) => {
    clearTimeout(self_.keyUpTimer);
    const val = $(e.currentTarget).val();

    if (self_.valBeforeKeyPress == val) return false;

    if (val.length > 1) {
      self_.keyUpTimer = setTimeout(() => {
        self_.performSearch_(val);
      }, 250);
    } else {
      self_.removeAutocompleteResult_();
    }
  });
};

TagsAutocomplete.prototype.bindTagsEvents_ = function () {
  const self_ = this;
  this.$form.on('click', '.feed-search-used-tags a', (event) => {
    const tagId = $(event.currentTarget).data('tagId');
    const categorySystemId = $(event.currentTarget).data('categorySystemId');
    if (tagId && tagId != '') {
      $(event.currentTarget).parents('span:first').remove();
      self_.removeTagFromSearchConditions_(tagId, categorySystemId);
    }
  });
};
TagsAutocomplete.prototype.bindFulltextEvents_ = function () {
  const self_ = this;

  this.$input.off('keydown.ta_').on('keydown.ta_', (e) => {
    // enter
    if (e.keyCode == 13) {
      if (self_.options.disableFormSubmit) {
        e.preventDefault();
      }
      self_.$input.trigger('AUTOCOMPLETE_FULLTEXT_CHANGED');
      self_.reRenderFormInputs_();
      self_.removeAutocompleteResult_();
      self_.rememberState($(e.currentTarget).val());
    }
  });
};

TagsAutocomplete.prototype.bindAutocompleteResultEvents_ = function () {
  const self_ = this;
  this.$input.off('keydown.ta_').on('keydown.ta_', (e) => {
    self_.valBeforeKeyPress = self_.$input.val();

    if ((self_.$renderedResult instanceof $)) {
      const liCnt = $('li', self_.$renderedResult).size();
      // down
      if (e.keyCode == 40) {
        e.preventDefault();
        if (self_.selectedItem < liCnt - 1) {
          self_.selectedItem++;
        }
      }

      // up
      if (e.keyCode == 38) {
        e.preventDefault();
        if (self_.selectedItem > 0) {
          self_.selectedItem--;
        }
      }

      // enter
      if (e.keyCode == 13) {
        if (self_.selectedItem > -1 && self_.selectedItem < $('li', self_.$renderedResult).size()) {
          e.preventDefault();
          self_.$input.trigger(self_.options.events.tagSelectedByUser);
          self_.addTagToSearchConditions({
            item: $(`li:eq(${self_.selectedItem}) > a`, self_.$renderedResult),
            resetQuery: true
          });
        } else {
          if (self_.options.disableFormSubmit) {
            e.preventDefault();
          }
          self_.$input.trigger('AUTOCOMPLETE_FULLTEXT_CHANGED');
          self_.reRenderFormInputs_();
          self_.removeAutocompleteResult_();
          self_.rememberState($(e.currentTarget).val());
        }
      }

      // escape
      if (e.keyCode == 27) {
        e.preventDefault();
        self_.removeAutocompleteResult_();
      }


      $('li', self_.$renderedResult).removeClass('active');
      if (self_.selectedItem > -1) {
        $(`li:eq(${self_.selectedItem})`, self_.$renderedResult).addClass('active');
      }
    }
  });

  $(this.$renderedResult).on('mouseover', 'li', (e) => {
    $('li', self_.$renderedResult).removeClass('active');
    $(e.currentTarget).addClass('active');
    self_.selectedItem = $('li', self_.$renderedResult).index(e.currentTarget);
  });

  $(this.$renderedResult).on('click', 'li > a', (e) => {
    self_.$input.trigger(self_.options.events.tagSelectedByUser);
    self_.addTagToSearchConditions({
      item: $(e.currentTarget),
      resetQuery: true
    });
  });

  this.$input.off('blur.ta_').on('blur.ta_', (e) => {
    e.preventDefault();
    setTimeout(() => {
      // self_.removeAutocompleteResult_();
    }, 100);
  });
};

TagsAutocomplete.prototype.performSearch_ = function (query) {
  const self_ = this;
  this.$t.addClass('loading');

  $.post(
    this.options.url, {
      query
    },
    (data) => {
      if (data && data.results && $.isArray(data.results) && data.results.length > 0) {
        const dataToSend = [];
        for (let i = 0; i < data.results.length; i++) {
        // check for non used tag
          if ($.inArray(data.results[i].id, window.feedTags) == -1 && (data.results[i].categorySystemId !== 'FRONTEND_AUTHOR' || (data.results[i].categorySystemId === 'FRONTEND_AUTHOR' && !self_.frontendAuthorTagUsed))) {
            dataToSend.push(data.results[i]);
          }
        }
        if (dataToSend.length > 0) {
          self_.renderResults_(dataToSend);
        } else if (self_.$renderedResult && self_.$renderedResult instanceof $) {
          self_.removeAutocompleteResult_();
        }
      } else if (self_.$renderedResult && self_.$renderedResult instanceof $) {
        self_.removeAutocompleteResult_();
      }
    }, 'json'
  );
};

TagsAutocomplete.prototype.renderResults_ = function (data) {
  const self_ = this;
  this.selectedItem = -1;
  const result = this.formatResults_(data);

  if (this.$renderedResult && this.$renderedResult instanceof $) {
    this.$renderedResult.remove();
  }
  if (result === '') {
    return false;
  }
  this.$t.removeClass('loading');
  this.$renderedResult = $(result).insertAfter(this.$t);
  this.$form.trigger(this.options.events.resultRendered);

  this.bindAutocompleteResultEvents_();
};

TagsAutocomplete.prototype.formatResults_ = function (data) {
  let result = '<div class="tags-autocomplete-result-wrapper"><ul class="tags-autocomplete-result">';
  for (let i = 0; i < data.length; i++) {
    result += '<li>';
    result += `	<a class="noPartialUpdate" href="javascript:void(0)" data-tag-id="${data[i].id}" data-category-system-id="${data[i].categorySystemId}" data-stackable="${data[i].stackable}" data-need-disclaimer="${data[i].needDisclaimer}" data-tag-name="${data[i].name}">${data[i].name}</a>`;
    result += '</li>';
  }
  result += '</ul></div>';
  return result;
};

TagsAutocomplete.prototype.removeAutocompleteResult_ = function () {
  if (this.$renderedResult && this.$renderedResult instanceof $) {
    this.$renderedResult.remove();
  }
  this.selectedItem = -1;
};

TagsAutocomplete.prototype.addTagToSearchConditions = function (data) {
  let tagId,
    tagName,
    tagNeedDisclaimer,
    categorySystemId;

  if (data.item) {
    const $item = data.item;
    tagId = $item.data('tagId');
    tagName = $item.data('tagName');
    tagNeedDisclaimer = $item.data('needDisclaimer');
    categorySystemId = $item.data('categorySystemId');
  } else if (data.itemMetadata) {
    tagId = data.itemMetadata.id;
    tagName = data.itemMetadata.name;
    tagNeedDisclaimer = data.itemMetadata.needDisclaimer;
    categorySystemId = data.itemMetadata.categorySystemId;
  }

  if ($.inArray(tagId, window.feedTags) > -1) {
    return false;
  }
  if (data.resetQuery) {
    this.$input.val('');
  }

  window.feedTags.push(tagId);
  window.feedTagsMetadata[`tag-${tagId}`] = {
    id: tagId, name: tagName, categorySystemId, needDisclaimer: tagNeedDisclaimer
  };
  if (categorySystemId === 'FRONTEND_AUTHOR') {
    this.frontendAuthorTagUsed = true;
  }
  if (categorySystemId !== 'CHILD_AGE') {
    this.addTagToUsedTagsContainer_(tagName, tagId, tagNeedDisclaimer, categorySystemId);
  }
  if (!data.disableRefresh) {
    this.$input.trigger('AUTOCOMPLETE_TAGS_CHANGED');
    this.refreshFormManually_({
      resetQuery: data.resetQuery
    });
  }
};

TagsAutocomplete.prototype.removeTagFromSearchConditions_ = function (tagId, categorySystemId, disableRefresh) {
  const isInArray = $.inArray(tagId, window.feedTags);
  if (isInArray > -1) {
    window.feedTags.splice(isInArray, 1);
  }
  if (categorySystemId === 'FRONTEND_AUTHOR') {
    this.frontendAuthorTagUsed = false;
  }
  if (!disableRefresh) {
    this.refreshFormManually_();
  }
};

TagsAutocomplete.prototype.clearAllSearchedTags_ = function () {
  for (let i = 0; i < window.feedTags.length; i++) {
    const id = window.feedTags[i];
    const categorySystemId = window.feedTagsMetadata[`tag-${window.feedTags[i]}`] ? window.feedTagsMetadata[`tag-${window.feedTags[i]}`].categorySystemId : 'GENERAL';
    this.removeTagFromSearchConditions_(id, categorySystemId, true);
  }
  window.feedTags = [];
};

TagsAutocomplete.prototype.reRenderFormInputs_ = function () {
  $(`input[name="${this.options.targetInputName}"]`, this.$form).remove();
  for (let i = 0; i < window.feedTags.length; i++) {
    this.$form.append(`<input type="hidden" name="${this.options.targetInputName}" value="${window.feedTags[i]}">`);
  }
};

TagsAutocomplete.prototype.renderInitialTags_ = function () {
  for (let i = 0; i < window.initialTags.length; i++) {
    const tag = window.initialTags[i];
    if (tag.categorySystemId !== 'CHILD_AGE') {
      this.addTagToUsedTagsContainer_(tag.name, tag.id, tag.needDisclaimer, '', this.options.lockTagsFromParams);
    }
  }
  this.reRenderFormInputs_();
  this.fixInputPadding_();
};

TagsAutocomplete.prototype.addTagToUsedTagsContainer_ = function (tagName, tagId, needDisclaimer, categorySystemId, locked) {
  this.$renderedUsedTagsContainer.append(`<span${locked ? ' class="tag-locked"' : ''}>${tagName}${locked ? '<b></b>' : `<a title="${this.options.messages.closeTag}" href="javascript:void(0)" data-tag-id="${tagId}" data-category-system-id="${categorySystemId}"></a>`}</span>`);

  if (needDisclaimer) {
    $('body').trigger(this.options.events.disclaimerTagSelected);
  }
};

TagsAutocomplete.prototype.prepareContainerForRenderedUsedTags_ = function () {
  if (this.$renderedUsedTagsContainer && this.$renderedUsedTagsContainer instanceof $) {
    return this.$renderedUsedTagsContainer;
  }
  return $('<div class="feed-search-used-tags"></div>').insertAfter(this.$t);
};

TagsAutocomplete.prototype.refreshFormManually_ = function (data) {
  this.reRenderFormInputs_();
  this.removeAutocompleteResult_();
  this.fixInputPadding_();
  this.$input.trigger(this.options.events.tagSelected);
  if (!data || !data.disableRememberForm) {
    this.rememberState((data && data.resetQuery) ? '' : undefined);
  }

  const submitFulltextButton = $('.feed-search-button');
  if (submitFulltextButton) {
    submitFulltextButton.trigger('click');
  }
};

TagsAutocomplete.prototype.fixInputPadding_ = function () {
  // if ($(window).width() >= 768) {
  this.$input.css({
    'padding-left' : `${this.inputPaddingLeft + this.$renderedUsedTagsContainer.outerWidth()}px`
  });
  // }
};

TagsAutocomplete.prototype.initLocalStorage_ = function () {
  if (!this.ls.getItem(LOCALSTORAGE_STATE_KEY)) {
    this.ls.setItem(LOCALSTORAGE_STATE_KEY, JSON.stringify({}));
  } else {
    try {
      if ((!document.referrer || document.referrer.indexOf(window.location.hostname) == -1) &&
				!(history && history.state && history.state.feedListing && history.state.feedListing.tags)
      ) {
        this.ls.setItem(LOCALSTORAGE_STATE_KEY, JSON.stringify({}));
      }
    } catch (message) {
      if (window.console && window.console.log) { console.log('Error message', message); }
    }
  }
};

TagsAutocomplete.prototype.rememberState = function (fulltextStr) {
  const state = JSON.parse(this.ls.getItem(LOCALSTORAGE_STATE_KEY));
  let tagMetadata = null;

  state.tags = [];
  state.tagsMetadata = {};

  for (let i = 0; i < window.feedTags.length; i++) {
    const tag = window.feedTags[i];
    state.tags.push(tag);
    if (window.feedTagsMetadata && window.feedTagsMetadata[`tag-${tag}`]) {
      tagMetadata = window.feedTagsMetadata[`tag-${tag}`];
      state.tagsMetadata[`tag-${tag}`] = {
        id: tagMetadata.id, name: tagMetadata.name, categorySystemId: tagMetadata.categorySystemId, needDisclaimer: tagMetadata.needDisclaimer
      };
    }
  }
  let fs = null;
  if (fulltextStr !== undefined) {
    fs = fulltextStr;
  } else if (state.fulltext !== undefined) {
    fs = state.fulltext;
  }

  if (typeof fs == 'string') {
    state.fulltext = fs;
  }

  state.lastUpdate = new Date().getTime();

  this.ls.setItem(LOCALSTORAGE_STATE_KEY, JSON.stringify(state));

  if (this.options.enableHtml5History) {
    this.utils.saveStateToHistory('feedListing', state);
  }
};

TagsAutocomplete.prototype.getRememberedState_ = function (type) {
  let state = {};
  if (history && history.state && history.state.feedListing) {
    state = history.state.feedListing;
  }
  if (type == 'ls') {
    state = JSON.parse(this.ls.getItem(LOCALSTORAGE_STATE_KEY));
  }

  // state is remembered
  if ($.isArray(state.tags) && state.tags.length > 0 || state.fulltext && state.fulltext !== '') {
    for (let i = 0; i < state.tags.length; i++) {
      const tag = state.tags[i];
      if (state.tagsMetadata[`tag-${tag}`]) {
        this.addTagToSearchConditions({
          itemMetadata: state.tagsMetadata[`tag-${tag}`],
          disableRefresh: true
        });
      } else {
        window.feedTags.push(tag);
      }
    }

    if (state.fulltext) {
      this.$fulltext.val(state.fulltext);
    }
  }
  // no state remembered, lets use primaryTags
  else if (this.options.primaryTags) {
    for (let j = 0; j < this.options.primaryTags.length; j++) {
      const primaryTag = this.options.primaryTags[j];
      this.addTagToSearchConditions({
        itemMetadata: primaryTag,
        disableRefresh: true
      });
    }
  }
  const storeData = {};
  storeData.disableRememberForm = (type === 'history');
  this.refreshFormManually_(storeData);
};

TagsAutocomplete.prototype.activateHistoryHandler_ = function () {
  const self_ = this;
  $(window).off('popstate.tagsautocomplete').on('popstate.tagsautocomplete', () => {
    self_.reloadDataFromHistory_();
  });

  if (history && history.state && history.state.feedListing && (history.state.feedListing.tags || history.state.feedListing.fulltext)) {
    this.reloadDataFromHistory_();
  }
};

TagsAutocomplete.prototype.reloadDataFromHistory_ = function () {
  this.$fulltext.val('');
  this.$renderedUsedTagsContainer.empty();
  this.clearAllSearchedTags_();
  if (history.state && history.state.feedListing) {
    this.getRememberedState_('history');
  } else {
    this.refreshFormManually_({
      disableRememberForm: true
    });
  }
};


/**
 * decide, which methods will be "public"
 */
const API = {
  addTagToSearchConditions: TagsAutocomplete.prototype.addTagToSearchConditions,
  rememberState: TagsAutocomplete.prototype.rememberState
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
  const args = arguments;

  return this.each(function () {
    const $this = $(this);

    // get plugin instance
    let plugin = $this.data(`plugin_${PLUGIN_NAME}`);

    // if there's not, create one
    if (!plugin) {
      plugin = new TagsAutocomplete(this, value);
      $this.data(`plugin_${PLUGIN_NAME}`, plugin);
    }
    // if there is and first parameter is in predefined API methods, call it with rest of params
    else if (API[value]) {
      plugin[value](...Array.prototype.slice.call(args, 1));
    }
  });
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.tags-autocomplete.js